import { render, staticRenderFns } from "./MedicinesTypeEdit.vue?vue&type=template&id=8f78332c&scoped=true&"
import script from "./MedicinesTypeEdit.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f78332c",
  null
  
)

export default component.exports